module.exports = __webpack_public_path__ + "static/img/zuoye.0eeb430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/zuoye.png
// module id = U317
// module chunks = 19